module.exports = __webpack_public_path__ + "static/img/zhongshan.4c700b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongshan.jpg
// module id = 4tgD
// module chunks = 0